export var PrincipalType;
(function (PrincipalType) {
    PrincipalType["MEMBER"] = "member";
    PrincipalType["GROUP"] = "group";
    PrincipalType["SERVICE_ACCOUNT"] = "serviceAccount";
    PrincipalType["MEMBER_WITHOUT_CRYPTO"] = "memberWithoutCrypto";
    PrincipalType["GROUP_WITHOUT_CRYPTO"] = "groupWithoutCrypto";
})(PrincipalType || (PrincipalType = {}));
export var PrincipalProvider;
(function (PrincipalProvider) {
    PrincipalProvider["LUCID"] = "lucid";
    PrincipalProvider["SCIM"] = "scim";
})(PrincipalProvider || (PrincipalProvider = {}));
